import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "folder",
  "use": "folder-usage",
  "viewBox": "0 0 17 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 13\" id=\"folder\">\n  <path fill-rule=\"evenodd\" d=\"M465.719,209.217l-3.04,3.655A3.515,3.515,0,0,1,460.29,214h-9.844a1.21,1.21,0,0,1-.548-0.12,0.413,0.413,0,0,1-.239-0.4,0.963,0.963,0,0,1,.28-0.61l3.041-3.655a3.048,3.048,0,0,1,1.089-.8,3.088,3.088,0,0,1,1.3-.328h9.845a1.209,1.209,0,0,1,.547.12,0.41,0.41,0,0,1,.239.4A0.96,0.96,0,0,1,465.719,209.217Zm-12.133-1.87a4.221,4.221,0,0,0-1.484,1.1l-3.049,3.656-0.046.055c0-.024,0-0.063,0-0.115s0-.091,0-0.115v-8.863a2.01,2.01,0,0,1,.6-1.459,1.932,1.932,0,0,1,1.43-.609h2.9a1.932,1.932,0,0,1,1.43.609,2.01,2.01,0,0,1,.6,1.459v0.295h4.922a1.932,1.932,0,0,1,1.43.609,2.013,2.013,0,0,1,.6,1.459v1.477h-7.528A4.175,4.175,0,0,0,453.586,207.347Z\" transform=\"translate(-449 -201)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/folder.svg
// module id = null
// module chunks = 